import apiClient from '@/utils/request';
import type { ApiResponse } from '@/types';

export interface LoginUser {
  id: number;
  name: string;
  email?: string | null;
  mobile?: string | null;
  job_title?: string | null;
  department?: string | null;
  avatar_url?: string | null;
  status?: string;
  feishu_open_id?: string | null;
  last_login_at?: string | null;
  created_at?: string | null;
  roles?: string[];
  role_names?: string[];
  permissions?: string[];
  /** 当前用户最高角色等级，用于用户角色分配的上限过滤 */
  max_rank?: number;
  /** 界面语言偏好，取 zh-CN / en（Phase 3 后端返回后生效） */
  language?: string;
}

export async function ensureCsrfCookie(): Promise<void> {
  await apiClient.get('/sanctum/csrf-cookie');
}

export async function logout(): Promise<void> {
  await ensureCsrfCookie();
  await apiClient.post('/api/logout');
}

export async function getUser(): Promise<LoginUser> {
  const { data } = await apiClient.get<ApiResponse<LoginUser>>('/api/user');
  return data.data;
}

/** 持久化用户语言偏好（PUT /api/user/preferences，Phase 3 后端接口） */
export async function updateLanguagePreference(language: string): Promise<void> {
  await apiClient.put<ApiResponse<{ language: string }>>('/api/user/preferences', { language });
}

/** 用飞书回调写入的 HttpOnly ticket Cookie 建立 Session，并返回当前用户 */
export async function consumeFeishuTicket(ticket?: string): Promise<LoginUser> {
  // consume 已排除 CSRF；仍先拉 csrf-cookie，确保 Sanctum stateful Session 已建立
  await ensureCsrfCookie();
  const { data } = await apiClient.post<ApiResponse<LoginUser>>(
    '/api/auth/feishu/consume',
    ticket ? { ticket } : {},
  );
  if (!data?.data) {
    throw new Error('consume response missing data');
  }
  return data.data;
}
